<template>
  <div>
    <Listbox v-model="selectLanguage">
      <div class="relative z-[22]">
        <ListboxButton
            class="relative w-full flex items-center cursor-pointer space-x-[6px] rtl:space-x-reverse"
        >
          <span class="inline-block md:h-6 md:w-6 w-7 h-7 rounded-full">
            <img :src="selectLanguage.image" alt="" class="h-full w-full object-cover rounded-full"/>
          </span>
<!--          <span class="text-sm md:block hidden font-medium text-slate-600 dark:text-slate-300">
            {{ selectLanguage.name }}
          </span>-->
        </ListboxButton>

        <Transition
            leave-active-class="transition duration-100 ease-in"
            leave-from-class="opacity-100"
            leave-to-class="opacity-0"
        >
          <ListboxOptions
              class="absolute min-w-[100px] ltr:right-0 rtl:left-0 md:top-[40px] top-[34px] w-auto max-h-60 overflow-auto border border-slate-200 dark:border-slate-700 rounded bg-white dark:bg-slate-800 mt-1"
          >
            <ListboxOption
                v-slot="{ active }"
                v-for="item in months"
                :key="item.name"
                :value="item"
                as="template"
            >
              <li
                  :class="[
                  active
                    ? 'bg-slate-100 dark:bg-slate-700 dark:bg-opacity-70 bg-opacity-50 dark:text-white '
                    : 'text-slate-600 dark:text-slate-300',
                  'w-full border-b border-b-gray-500 border-opacity-10 px-2 py-2 last:border-none last:mb-0 cursor-pointer first:rounded-t last:rounded-b',
                ]"
              >
                <div class="flex items-center space-x-2 rtl:space-x-reverse">
                  <span class="flex-none">
                    <span
                        class="lg:w-6 lg:h-6 w-4 h-4 rounded-full inline-block"
                    >
                      <img
                          :src="item.image"
                          alt=""
                          class="w-full h-full object-cover relative top-1 rounded-full"
                      />
                    </span>
                  </span>
                  <span class="flex-1 lg:text-base text-sm capitalize">
                    {{ item.name }}</span
                  >
                </div>
              </li>
            </ListboxOption>
          </ListboxOptions>
        </Transition>
      </div>
    </Listbox>
  </div>
</template>

<script>
import langImg1 from "@/assets/images/flags/usa.png"
import langImg2 from "@/assets/images/flags/iran.png"
import {ref, watch} from "vue";
import {useThemeSettingsStore} from "@/stores/themeSettings";
import {
  Listbox,
  ListboxButton,
  ListboxOptions,
  ListboxOption,
} from "@headlessui/vue";
import {useI18n} from 'vue-i18n';

export default {
  components: {
    Listbox,
    ListboxButton,
    ListboxOptions,
    ListboxOption
  },
  setup() {
    const themeSettingsStore = useThemeSettingsStore()
    const direction = ref(themeSettingsStore.direction)
    const months = [
      {name: "en", image: langImg1, direction: false},
      {name: "fa", image: langImg2, direction: true},
    ];
    const selectLanguage = ref(months.find(language => language.name === themeSettingsStore.language));
    const {t, locale} = useI18n({useScope: 'global'})


    const changeLocale = (myLocale) => {
      //console.log(myLocale.name)
      locale.value = myLocale.name
      themeSettingsStore.setLanguage(myLocale.name)

      // Set data-lang attribute on body to change font styles
      direction.value = myLocale.direction
      document.body.setAttribute('data-lang', myLocale.name);
    };

    watch(selectLanguage, () => {
      changeLocale(selectLanguage.value)
    }, { immediate: true });

    watch(direction, () => {
      if (direction.value) {
        themeSettingsStore.direction = direction.value;
        document.documentElement.setAttribute("dir", "rtl");
        localStorage.setItem("direction", direction.value);
      } else {
        themeSettingsStore.direction = direction.value;
        document.documentElement.setAttribute("dir", "ltr");
        localStorage.setItem("direction", direction.value);
      }
    }, { immediate: true });

    return {
      months,
      selectLanguage,
      t,
      locale,
      changeLocale
    }
  }
}

</script>
